<script>
import Warnings from "../components/Alerts/Warnings.vue";
import LoaderSpinner from "../components/Loaders/LoaderSpinner.vue";
import StreamerInfo from "../components/StreamerInfo.vue";
import LoaderPage from "../components/Loaders/LoaderPage.vue";
import AudioRecorder from "../components/audioComponents/AudioRecorder.vue";
import InputSwitch from "../components/inputs/InputSwitch.vue";
import { useToast } from "vue-toastification";
import CryptoJS from "crypto-js";
import ModalTemplate from "../components/modals/ModalTemplate.vue";
import Overlay from "../components/overlay/overlay.vue";

export default {
  name: "checkout-page",
  components: {
    StreamerInfo,
    Warnings,
    LoaderSpinner,
    LoaderPage,
    AudioRecorder,
    InputSwitch,
    ModalTemplate,
    Overlay,
  },
  data() {
    return {
      toggleLoaderPage: true,
      username: this.$route.params.username,
      maxCharsNickName: 40,
      maxAudioDuration: 15,
      maxChars: 250,
      message: "",
      streamerInfo: {},
      checkoutInfo: {
        streamerId: null,
        donatorNickname: "",
        donatorMessage: "",
        donatorAmount: null,
        minimumDonateAmount: null,
        fileId: null,
        country: "Brazil",
      },
      pixUrl: "",
      qrCodeForm: false,
      qrCodeFormSlide: false,
      thanksForMessage: true,
      thanksForMessageSlide: false,
      paymentFormError: "",
      paymentFormLoader: false,
      toggleTypeMessage: true,
      toggleVoiceType: true,
      paymentForm: true,
      form: {
        selectIaVoice: false,
      },
      loader: {
        selectIaVoice: false,
      },
      disabledButton: {
        generatedIa: true,
      },
      text: {
        selectIaVoice: null,
        copyCode: "COPIAR CÓDIGO PIX",
      },
      dataIA: [],
      isPlaying: true,
      audioId: null,
      taskId: null,
      callCount: 0,
      clearTimeout: false,
      stopGenerated: false,
      prototypeFunction: process.env.VUE_SIGN,
      openModal: {
        currentCountry: false,
      },
      countrySettings: {},
      COUNTRY_SETTINGS: {
        Brazil: {
          symbol: "R$",
          minimumLabel: "Valor mínimo",
        },
        UnitedStates: {
          name: "United States",
          currency: "USD",
          symbol: "$",
          buttonText: "Continue Payment of",
          flag: "us.svg",
          message: "You're in the United States",
          minimumLabel: "Minimum amount",
        },
        Portugal: {
          name: "Portugal",
          currency: "EUR",
          symbol: "€",
          buttonText: "Continuar pagamento de",
          flag: "pt.svg",
          message: "Você está em Portugal",
          minimumLabel: "Valor mínimo",
        },
        Mexico: {
          name: "México",
          currency: "MXN",
          symbol: "$",
          buttonText: "Continuar pago de",
          flag: "mx.svg",
          message: "Estás en México",
          minimumLabel: "Monto mínimo",
        },
        India: {
          name: "India",
          currency: "INR",
          symbol: "₹",
          buttonText: "भुगतान जारी रखें",
          flag: "in.svg",
          message: "आप भारत में हैं",
          minimumLabel: "न्यूनतम राशि",
        },
        Spain: {
          name: "España",
          currency: "EUR",
          symbol: "€",
          buttonText: "Continuar con el pago de",
          flag: "es.svg",
          message: "Estás en España",
          minimumLabel: "Importe mínimo",
        },
        France: {
          name: "France",
          currency: "EUR",
          symbol: "€",
          buttonText: "Continuer le paiement de",
          flag: "fr.svg",
          message: "Vous êtes en France",
          minimumLabel: "Montant minimum",
        },
        Italy: {
          name: "Italia",
          currency: "EUR",
          symbol: "€",
          buttonText: "Continua il pagamento di",
          flag: "it.svg",
          message: "Sei in Italia",
          minimumLabel: "Importo minimo",
        },
        Canada: {
          name: "Canada",
          currency: "CAD",
          symbol: "$",
          buttonText: "Continue Payment of",
          flag: "ca.svg",
          message: "You're in Canada",
          minimumLabel: "Minimum amount",
        },
        Germany: {
          name: "Deutschland",
          currency: "EUR",
          symbol: "€",
          buttonText: "Zahlung fortsetzen von",
          flag: "de.svg",
          message: "Sie sind in Deutschland",
          minimumLabel: "Mindestbetrag",
        },
        UnitedKingdom: {
          name: "United Kingdom",
          currency: "GBP",
          symbol: "£",
          buttonText: "Continue Payment of",
          flag: "gb.svg",
          message: "You're in the United Kingdom",
          minimumLabel: "Minimum amount",
        },
        Austria: {
          name: "Österreich",
          currency: "EUR",
          symbol: "€",
          buttonText: "Zahlung fortsetzen von",
          flag: "at.svg",
          message: "Sie sind in Österreich",
          minimumLabel: "Mindestbetrag",
        },
        Belgium: {
          name: "Belgique",
          currency: "EUR",
          symbol: "€",
          buttonText: "Continuer le paiement de",
          flag: "be.svg",
          message: "Vous êtes en Belgique",
          minimumLabel: "Montant minimum",
        },
        Cyprus: {
          name: "Κύπρος",
          currency: "EUR",
          symbol: "€",
          buttonText: "Συνέχεια πληρωμής",
          flag: "cy.svg",
          message: "Βρίσκεστε στην Κύπρο",
          minimumLabel: "Ελάχιστο ποσό",
        },
        Croatia: {
          name: "Hrvatska",
          currency: "EUR",
          symbol: "€",
          buttonText: "Nastavi s plaćanjem",
          flag: "hr.svg",
          message: "Nalazite se u Hrvatskoj",
          minimumLabel: "Minimalni iznos",
        },
        Slovakia: {
          name: "Slovensko",
          currency: "EUR",
          symbol: "€",
          buttonText: "Pokračovať v platbe",
          flag: "sk.svg",
          message: "Ste na Slovensku",
          minimumLabel: "Minimálna suma",
        },
        Slovenia: {
          name: "Slovenija",
          currency: "EUR",
          symbol: "€",
          buttonText: "Nadaljuj s plačilom",
          flag: "si.svg",
          message: "Ste v Sloveniji",
          minimumLabel: "Minimalni znesek",
        },
        Estonia: {
          name: "Eesti",
          currency: "EUR",
          symbol: "€",
          buttonText: "Jätka maksmist",
          flag: "ee.svg",
          message: "Olete Eestis",
          minimumLabel: "Minimaalne summa",
        },
        Finland: {
          name: "Suomi",
          currency: "EUR",
          symbol: "€",
          buttonText: "Jatka maksamista",
          flag: "fi.svg",
          message: "Olet Suomessa",
          minimumLabel: "Vähimmäismäärä",
        },
        Greece: {
          name: "Ελλάδα",
          currency: "EUR",
          symbol: "€",
          buttonText: "Συνέχεια πληρωμής",
          flag: "gr.svg",
          message: "Βρίσκεστε στην Ελλάδα",
          minimumLabel: "Ελάχιστο ποσό",
        },
        Ireland: {
          name: "Ireland",
          currency: "EUR",
          symbol: "€",
          buttonText: "Continue Payment of",
          flag: "ie.svg",
          message: "You're in Ireland",
          minimumLabel: "Minimum amount",
        },
        Latvia: {
          name: "Latvija",
          currency: "EUR",
          symbol: "€",
          buttonText: "Turpināt maksājumu",
          flag: "lv.svg",
          message: "Jūs esat Latvijā",
          minimumLabel: "Minimālā summa",
        },
        Lithuania: {
          name: "Lietuva",
          currency: "EUR",
          symbol: "€",
          buttonText: "Tęsti mokėjimą",
          flag: "lt.svg",
          message: "Jūs esate Lietuvoje",
          minimumLabel: "Minimali suma",
        },
        Luxembourg: {
          name: "Lëtzebuerg",
          currency: "EUR",
          symbol: "€",
          buttonText: "Continuer le paiement de",
          flag: "lu.svg",
          message: "Vous êtes au Luxembourg",
          minimumLabel: "Montant minimum",
        },
        Malta: {
          name: "Malta",
          currency: "EUR",
          symbol: "€",
          buttonText: "Kompli bil-ħlas ta’",
          flag: "mt.svg",
          message: "Int qiegħed Malta",
          minimumLabel: "Ammont minimu",
        },
        Netherlands: {
          name: "Nederland",
          currency: "EUR",
          symbol: "€",
          buttonText: "Doorgaan met betaling van",
          flag: "nl.svg",
          message: "Je bent in Nederland",
          minimumLabel: "Minimum bedrag",
        },
        Andorra: {
          name: "Andorra",
          currency: "EUR",
          symbol: "€",
          buttonText: "Continua el pagament de",
          flag: "ad.svg",
          message: "Ets a Andorra",
          minimumLabel: "Import mínim",
        },
        Monaco: {
          name: "Monaco",
          currency: "EUR",
          symbol: "€",
          buttonText: "Continuer le paiement de",
          flag: "mc.svg",
          message: "Vous êtes à Monaco",
          minimumLabel: "Montant minimum",
        },
        SanMarino: {
          name: "San Marino",
          currency: "EUR",
          symbol: "€",
          buttonText: "Continua il pagamento di",
          flag: "sm.svg",
          message: "Sei a San Marino",
          minimumLabel: "Importo minimo",
        },
        Australia: {
          name: "Australia",
          currency: "AUD",
          symbol: "A$",
          buttonText: "Continue Payment of",
          flag: "au.svg",
          message: "You're in Australia",
          minimumLabel: "Minimum amount",
        },
      }
    };
  },
  computed: {
    charsLeft() {
      return this.checkoutInfo.donatorMessage.length;
    },
  },
  methods: {
    convertedNumber(value) {
      value = value.toString();
      return parseFloat(value.replace(/[^\d,]/g, "").replace(",", "."));
    },
    formatCurrency(value) {
      if (!value) return "";

      // Remove todos os caracteres não numéricos
      const numericValue = value.replace(/[^0-9]+/g, "");

      // Verifica o número de dígitos
      const numDigits = numericValue.length;

      // Calcula o valor em centavos
      const cents =
        numDigits > 2
          ? numericValue.slice(numDigits - 2)
          : numericValue.padStart(2, "0");
      const integerPart =
        numDigits > 2
          ? numericValue.slice(0, numDigits - 2).replace(/^0+/, "")
          : "0";

      // Formata o valor adicionando o separador de milhar
      const formattedIntegerPart = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        "."
      );

      // Adiciona o símbolo de moeda e a parte decimal
      const formattedValue = `${formattedIntegerPart == "" ? "0" : formattedIntegerPart
        },${cents}`;

      // Adiciona o símbolo de moeda
      return formattedValue;
    },
    charCountStyle() {
      switch (true) {
        case this.charsLeft >= 250:
          return "color: red; font-weight: 900";
        case this.charsLeft >= 240:
          return "color: red; font-weight: 700";
        case this.charsLeft >= 200:
          return "color: orange";
        case this.charsLeft >= 150:
          return "color: goldenrod";
      }
    },
    validateFields() {
      if (
        !this.checkoutInfo.donatorAmount ||
        !this.checkoutInfo.donatorNickname ||
        !(this.checkoutInfo.donatorMessage || this.checkoutInfo.fileId) ||
        !this.checkoutInfo.streamerId
      ) {
        this.paymentFormError = "Todos os campos devem ser preenchidos";
        return false;
      }
      if (this.checkoutInfo.donatorNickname.length > this.maxCharsNickName) {
        this.paymentFormError = `O nome deve ter no máximo ${this.maxCharsNickName} caracteres`;
        return false;
      }
      if (this.checkoutInfo.donatorMessage.length > this.maxChars) {
        this.paymentFormError = `A mensagem deve ter no máximo ${this.maxChars} caracteres`;
        return false;
      }
      if (this.toggleTypeMessage) {
        if (
          this.convertedNumber(this.checkoutInfo.donatorAmount) <
          this.streamerInfo.minimumDonateAmount
        ) {
          this.paymentFormError = `${this.countrySettings.minimumLabel || "Valor mínimo:"
            }: ${this.countrySettings.symbol} ${this.formatAmount(
              this.streamerInfo.minimumDonateAmount ?? 1.0
            )}`;
          $("#minDonate").css({
            color: "red",
            "font-weight": "700",
          });
          return false;
        }
      } else {
        if (
          this.convertedNumber(this.checkoutInfo.donatorAmount) <
          this.streamerInfo.minimumAudioDonateAmount
        ) {
          this.paymentFormError = `${this.countrySettings.minimumLabel || "Valor mínimo:"
            }: ${this.countrySettings.symbol} ${this.formatAmount(
              this.streamerInfo.minimumAudioDonateAmount ?? 1.0
            )}`;
          $("#minDonate").css({
            color: "red",
            "font-weight": "700",
          });
          return false;
        }
      }

      return true;
    },

    transaction() {
      if (!this.validateFields()) return;

      if (
        this.toggleVoiceType &&
        this.streamerInfo.isAIActivated &&
        this.toggleTypeMessage
      ) {
        return this.getIaVoices();
      }

      if (this.checkoutInfo.country !== "Brazil") {
        this.openModal.currentCountry = true;
        return;
      }

      this.createTransaction();
    },
    formatPrice(value) {
      return Number(value).toFixed(2);
    },
    getIpLocation() {
      this.$axios
        .get(
          "https://yotmohfuxsn63kovsomw4wexbi0qcyqz.lambda-url.us-east-1.on.aws/ip-location"
        )
        .then((res) => {
          const countryKey = res.data.country.replace(" ", "");
          const countryData = this.COUNTRY_SETTINGS[countryKey];
          if (countryData) {
            this.checkoutInfo.country = countryKey;
            this.countrySettings = countryData;
          }
        })
        .catch((err) => {
          return false;
        });
    },

    createTransaction(typePayment) {
      this.paymentFormLoader = true;

      this.$axios
        .post(`/checkouts`, {
          ...this.checkoutInfo,
          iaModel: this.checkoutInfo.voiceId,
          donatorAmount: this.convertedNumber(this.checkoutInfo.donatorAmount),
        })
        .then((res) => {
          // Stripe Payment
          if (res.data.paymentLink && typePayment == "stripe") {
            return (window.location.href = res.data.paymentLink);
          }

          this.pixUrl = res.data.pixUrl;
          this.generateQrCode(res.data.pixUrl);
          this.openModal.currentCountry = false;
          this.qrCodeFormSlide = true;
          this.paymentForm = false;
          this.qrCodeForm = true;
          this.thanksForMessage = true;
          this.form.selectIaVoice = false;

          let pusher = new Pusher("787e05d557a8480c3ee7", {
            cluster: "mt1",
          });

          let channel = pusher.subscribe(res.data.transactionId + "");
          let that = this;

          channel.bind("pix-payment", function (data) {
            if (data.message == "Paid") {
              that.qrCodeForm = false;
              that.thanksForMessageSlide = true;
            }
          });
        })
        .finally(() => {
          this.paymentFormLoader = false;
        });
    },
    selectPaymentMethod(type) {
      switch (type) {
        case "stripe":
          break;
        case "pix":
          break;

        default:
          break;
      }
    },
    getIaVoices() {
      if (!this.validateFields()) return;
      this.paymentFormLoader = true;
      this.$axios
        .get("AIVoices/list-models")
        .then((res) => {
          this.dataIA = res.data.models;
          this.paymentForm = false;
          this.form.selectIaVoice = true;
        })
        .catch((err) => {
          useToast().error("Erro desconhecido!");
        })
        .finally(() => {
          this.paymentFormLoader = false;
        });
    },

    generatedIaVoiceId(voiceId) {
      this.text.selectIaVoice = "Estamos gerando seu áudio";
      this.loader.selectIaVoice = true;
      this.disabledButton.generatedIa = true;
      this.checkoutInfo.voiceId = voiceId;
      var that = this;
      var fb = this.fbp();

      this.$axios
        .post(
          "AIVoices",
          {
            voiceId: voiceId,
            message: this.checkoutInfo.donatorMessage,
            donatorNickname: this.checkoutInfo.donatorNickname,
            donatorAmount: this.convertedNumber(
              this.checkoutInfo.donatorAmount
            ),
            streamerId: this.checkoutInfo.streamerId,
          },
          { headers: { _fbclid: fb } }
        )
        .then((res) => {
          this.taskId = res.data.TaskId;

          this.qrCodeForm = true;

          setTimeout(() => {
            this.getGeneratedIaVoice(this.taskId);
          }, 3000);
        })

        .catch((err) => {
          useToast().error(
            "Houve um erro ao tentar gerar o seu áudio, por favor, tente novamente!"
          );
        });
    },

    getGeneratedIaVoice(taskId) {
      this.loader.selectIaVoice = true;
      this.callCount++;

      if (this.callCount == 5) {
        useToast().info(
          "Está demorando mais que o normal. Continuando a gerar ou mande sua mensagem sem a voz por IA..."
        );
      }

      if (this.callCount >= 10) {
        this.stopGenerated = true;
        this.paymentForm = true;
        this.form.selectIaVoice = false;
        this.text.selectIaVoice = null;
        this.loader.selectIaVoice = false;
        this.audioId = null;
        useToast().error(
          "Não foi possivel gerar seu audio, por favor tente novamente!"
        );
        this.toggleVoiceType = false;
      }
      if (this.stopGenerated) return;
      this.$axios
        .get(`AIVoices/${taskId}`)
        .then((res) => {
          this.voiceData = res.data;
          if (!this.voiceData.aiFileId) {
            setTimeout(() => {
              this.getGeneratedIaVoice(this.taskId);
            }, 3000);
          } else {
            this.checkoutInfo = {
              ...this.checkoutInfo,
              iaModel: this.checkoutInfo.voiceId,
              iaFileId: this.voiceData.aiFileId,
            };
            if (this.checkoutInfo.country !== "Brazil") {
              this.openModal.currentCountry = true;
              return;
            }
            this.createTransaction();
          }
        })
        .catch((err) => {
          useToast().error(
            "Houve um erro ao tentar gerar o seu audio, por favor tente novamente!"
          );
        });
    },

    modelSample(setAudio, id) {
      this.disabledButton.generatedIa = false;
      this.isPlaying = true;
      if (id == this.setAudioId) return;
      this.audioId = id;
      const audio = new Audio(setAudio);

      audio.play();

      audio.addEventListener("ended", () => {
        this.isPlaying = false;
      });
    },

    generateQrCode(pixUrl) {
      const QRCodeMaker = require("qrcode-generator");
      const qrcode = QRCodeMaker(16, "Q");
      const text = pixUrl;
      qrcode.addData(text);
      qrcode.make();
      const matrix = qrcode.getModuleCount();
      const image = qrcode.createImgTag(4, 0);
      $("#qrcode").html(image);
    },

    copiarURL() {
      const el = document.createElement("textarea");
      el.value = this.pixUrl;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      useToast().success("Código copiado com sucesso!");
      this.text.copyCode = "Código copiado!";
    },

    resetInputs() {
      this.checkoutInfo.donatorAmount = "";
      this.checkoutInfo.donatorNickname = "";
      this.checkoutInfo.donatorMessage = "";
      window.location.reload();
    },
    switchIaVoice(voiceIa) {
      this.toggleVoiceType = voiceIa;
    },
    formatAmount(amount) {
      if (amount) {
        return amount.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          minimumIntegerDigits: 1,
        });
      }
    },
    fbp() {
      var t = `${this.checkoutInfo.voiceId}+${this.checkoutInfo.donatorNickname}+${this.checkoutInfo.donatorMessage}+${this.checkoutInfo.streamerId}`;
      const e = CryptoJS.enc.Utf8.parse(t),
        o = CryptoJS.enc.Utf8.parse("getPrototypeOf"),
        c = CryptoJS.HmacSHA256(e, o);
      return (this.hmacSha256Hex = c.toString(CryptoJS.enc.Hex));
    },
    getFlagPath(flagName) {
      return new URL(`../assets/flags/${flagName}`, import.meta.url).href;
    },
  },
  created() {
    this.getIpLocation();

    this.$axios
      .get(`/checkouts`, {
        params: {
          streamerUsername: this.username,
        },
      })
      .then((res) => {
        this.checkoutInfo.streamerId = res.data.id;
        this.streamerInfo = res.data;
        // if (this.checkoutInfo.country !== "Brazil") {
        //   this.streamerInfo.minimumDonateAmount = 1;
        // }
        if (this.streamerInfo.backgroundImage) {
          this.$emit("set-checkout-background", true);
        }
        if (res.data.maxMessageLength) {
          this.maxChars = res.data.maxMessageLength;
        }
        if (res.data.maxAudioDuration) {
          this.maxAudioDuration = res.data.maxAudioDuration;
        }
      })
      .catch((err) => {
        switch (err.response.status) {
          case 404:
            this.$router.push("/404");
            break;
        }
      })
      .finally(() => {
        this.toggleLoaderPage = false;
      });
  },
};
</script>


<template>
  <span style="width: 100%">
    <Transition>
      <img
        v-show="streamerInfo.backgroundImage"
        id="bg-image-checkout"
        :src="streamerInfo.backgroundImage"
        alt="background-image"
        fetchpriority="high"
        rel="preload" />
    </Transition>
    <section
      class="content-center"
      :class="{ isBackgroundImage: streamerInfo.backgroundImage }">
      <Transition>
        <div v-show="paymentForm" id="payment-form">
          <StreamerInfo :infos-data="streamerInfo" />
          <form
            @submit="transaction()"
            v-on:submit.prevent="onSubmit"
            class="form-content">
            <div class="form-body">
              <input
                v-model="checkoutInfo.donatorNickname"
                type="text"
                inputmode="text"
                placeholder="Seu nick do chat"
                style="margin-bottom: 1rem"
                :maxlength="maxCharsNickName" />

              <div
                v-show="streamerInfo.acceptAudioDonate"
                class="contentTypeMessage">
                <i
                  @click="
                    (toggleTypeMessage = true),
                    (checkoutInfo.fileId = null),
                    (checkoutInfo.donatorAmount = ''),
                    (paymentFormError = '')
                    "
                  :style="{
                    opacity: toggleTypeMessage ? 1 : 0.6,
                    color: streamerInfo.checkoutPrimaryColor,
                  }"
                  class="bx bx-text controlerButton"></i>
                <i
                  @click="
                    (toggleTypeMessage = false),
                    (checkoutInfo.donatorMessage = ''),
                    (checkoutInfo.donatorAmount = ''),
                    (paymentFormError = '')
                    "
                  :style="{
                    opacity: !toggleTypeMessage ? 1 : 0.6,
                    color: streamerInfo.checkoutPrimaryColor,
                  }"
                  class="bx bxs-microphone controlerButton"></i>
              </div>

              <div class="fadeDown" v-show="toggleTypeMessage">
                <textarea
                  placeholder="Mensagem"
                  style="height: 70px"
                  v-model="checkoutInfo.donatorMessage"
                  :maxlength="maxChars">
                </textarea>
                <p class="inputDescription" :style="charCountStyle()">
                  Restam {{ maxChars - charsLeft }} caracteres
                </p>
              </div>
              <AudioRecorder
                class="fadeDown"
                v-show="!toggleTypeMessage"
                :color="streamerInfo.checkoutPrimaryColor"
                @fileId="checkoutInfo.fileId = $event"
                :totalTime="maxAudioDuration" />

              <div
                v-show="toggleTypeMessage"
                class="fadeDown priceInputContent">
                <span>{{ countrySettings.symbol }}</span>
                <input
                  v-model.number="checkoutInfo.donatorAmount"
                  type="tel"
                  inputmode="tel"
                  maxlength="9"
                  min="100"
                  @input="
                    checkoutInfo.donatorAmount = formatCurrency(
                      $event.target.value
                    )
                    " />
              </div>
              <p
                v-show="toggleTypeMessage"
                id="minDonate"
                class="fadeDown inputDescription"
                style="margin-top: 5px">
                {{ countrySettings.minimumLabel || "Valor mínimo" }}:
                {{ countrySettings.symbol ?? 'R$' }}
                {{ formatAmount(streamerInfo.minimumDonateAmount) }}
              </p>
              <InputSwitch
                v-if="toggleTypeMessage && streamerInfo.isAIActivated"
                setLabel="Escolher narrador por IA:"
                :switchValue="toggleVoiceType"
                @switch-clicked="switchIaVoice"
                styleLabel="font-size: 14px; color: var(--grey)"
                :colorChecked="streamerInfo.checkoutPrimaryColor" />

              <div
                v-show="!toggleTypeMessage"
                class="fadeDown priceInputContent">
                <span>{{ countrySettings.symbol }}</span>
                <input
                  v-model.number="checkoutInfo.donatorAmount"
                  type="tel"
                  inputmode="tel"
                  maxlength="9"
                  min="100"
                  @input="
                    checkoutInfo.donatorAmount = formatCurrency(
                      $event.target.value
                    )
                    " />
              </div>
              <p
                v-show="!toggleTypeMessage"
                id="minDonate"
                class="fadeDown inputDescription"
                style="margin-top: 5px">
                {{ countrySettings.minimumLabel || "Valor mínimo:" }}:
                {{ countrySettings.symbol }}
                {{ formatAmount(streamerInfo.minimumAudioDonateAmount) }}
              </p>

              <button
                :style="{ backgroundColor: streamerInfo.checkoutPrimaryColor }"
                type="submit"
                class="btn btn-primary"
                :disabled="paymentFormLoader">
                <LoaderSpinner v-show="paymentFormLoader" />
                Continuar
              </button>

              <Warnings
                warning-type="error"
                :set-description="paymentFormError"
                @close-warning="paymentFormError = null" />
            </div>
          </form>
          <small>Ao utilizar nosso serviço, você concorda com os nossos
            <router-link to="/termos-de-uso">termos de uso</router-link>
          </small>
        </div>
      </Transition>

      <Transition>
        <div v-show="form.selectIaVoice" id="payment-form">
          <StreamerInfo :infos-data="streamerInfo" />
          <form
            @submit="generatedIaVoiceId(this.audioId)"
            v-on:submit.prevent="onSubmit"
            class="form-content">
            <h2>Voz por IA</h2>
            <div class="form-body">
              <div class="contentCards">
                <div
                  @click="modelSample(data.modelSample, data.modelId)"
                  v-for="data in dataIA"
                  :key="data.modelId"
                  class="cardIA">
                  <div
                    :style="{
                      border:
                        audioId == data.modelId
                          ? `3px solid ${streamerInfo.checkoutPrimaryColor}`
                          : 'none',
                    }"
                    :class="{ selected: audioId == data.modelId }"
                    class="cardIcon">
                    <span
                      :style="`background-color: ${streamerInfo.checkoutPrimaryColor}`"
                      class="overlay"></span>
                    <i
                      v-show="audioId == data.modelId && isPlaying"
                      class="bx bx-volume-full"></i>
                    <img :src="data.modelImage" alt="Icone do narrador" />
                  </div>

                  <p>{{ data.modelName }}</p>
                </div>
              </div>
              <button
                :style="{
                  backgroundColor: streamerInfo.checkoutPrimaryColor,
                  gap: '0px',
                }"
                type="submit"
                class="btn btn-primary"
                :class="{ 'dot-animation': text.selectIaVoice }"
                :disabled="disabledButton.generatedIa">
                {{ text.selectIaVoice ?? "Continuar" }}
                <LoaderSpinner
                  v-show="loader.selectIaVoice && !text.selectIaVoice" />
              </button>
            </div>
          </form>
          <small>Ao utilizar nosso serviço, você concorda com os nossos
            <router-link to="/termos-de-uso">termos de uso</router-link>
          </small>
        </div>
      </Transition>

      <Transition>
        <div
          id="qrCode-form"
          :class="{ 'slide-animation': qrCodeFormSlide }"
          v-show="qrCodeForm">
          <div
            class="form-content"
            :style="qrCodeFormSlide ? { opacity: 1 } : {}">
            <div class="form-body">
              <p>Este código PIX será válido por 15 minutos</p>
              <div class="qrcode-content-checkout">
                <div id="qrcode"></div>
              </div>
              <p class="text-center">Pix Copia e Cola</p>
              <button class="btn btn-primary" @click="copiarURL">
                {{ text.copyCode }}
              </button>
            </div>
          </div>
          <small>Ao utilizar nosso serviço, você concorda com os nossos
            <router-link to="/termos-de-uso">termos de uso</router-link>
          </small>
        </div>
      </Transition>

      <Transition>
        <div
          v-show="thanksForMessage"
          id="thanksForMessage"
          :style="thanksForMessageSlide ? { opacity: 1 } : {}"
          :class="{ 'slide-animation': thanksForMessageSlide }">
          <StreamerInfo :infos-data="streamerInfo" />
          <form v-on:submit.prevent="onSubmit" class="form-content">
            <div class="form-body">
              <h2>Feito!</h2>
              <p>Sua mensagem já já será exibida na transmissão.</p>
              <button class="btn btn-primary" @click="resetInputs()">
                Fazer outra contribuição
              </button>
            </div>
          </form>
        </div>
      </Transition>
    </section>
    <LoaderPage v-show="toggleLoaderPage" />
  </span>
  <Transition>
    <ModalTemplate
      v-if="openModal.currentCountry"
      @close="openModal.currentCountry = $event"
      maxWidth="400px">
      <template #body>
        <div class="content-body" v-if="countrySettings">
          <img
            :src="require(`@/assets/flags/${countrySettings.flag}`)"
            alt="Bandeira"
            width="32"
            height="20" />

          <p>{{ countrySettings.message }}</p>

          <button
            @click="createTransaction('stripe')"
            :style="{ backgroundColor: streamerInfo.checkoutPrimaryColor }"
            class="btn btn-primary">
            {{ countrySettings.buttonText }}
            {{ countrySettings.symbol }}
            {{ formatPrice(convertedNumber(checkoutInfo.donatorAmount)) }}
          </button>

          <span @click="createTransaction()" class="btn-link">Pagar com pix</span>
        </div>
      </template>
    </ModalTemplate>
  </Transition>
  <Overlay :closeModal="openModal.currentCountry" @closeModal="openModal.currentCountry = $event" />
</template>

<style scoped>
.inputDescription {
  display: block;
  text-align: right;
  font-size: 12px;
  font-weight: 500px;
  margin: 0px 0px 5px;
  transition: var(--slow-med);
}

.form-content {
  margin-top: 20px;
}

#payment-form {
  position: absolute;
  right: 50%;
  top: 50%;
  transform: translate(50%, -50%);
  width: 100%;
}

#qrCode-form,
#thanksForMessage {
  position: absolute;
  right: 0%;
  top: 50%;
  transform: translate(100%, -50%);
  transition: var(--slow-med) ease-in;
  opacity: 0;
}

.slide-animation {
  right: 50% !important;
  transform: translate(50%, -50%) !important;
  opacity: 1 !important;
}

#qrCode-form p {
  font-size: 16px;
  color: var(--grey-2);
  font-weight: 500;
  margin: 0px;
}

#thanksForMessage h2 {
  font-weight: 700;
  font-size: 25px;
  color: var(--black);
}

#thanksForMessage p {
  font-weight: 400;
  font-size: 18px;
  color: var(--black);
  text-align: left;
}

#qrCode-form .qrcode-content p {
  color: #000;
  font-weight: 700;
  margin: 5px 0px;
}

.contentTypeMessage {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.controlerButton {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--slow-med);
  background: var(--grey-6);
  border-radius: 3px;
  padding: 3px;
  border: 1px solid var(--white);
  opacity: 0.6;
}

.controlerButton:hover {
  opacity: 1;
}

textarea {
  margin-top: 0px;
}

#bg-image-checkout {
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100%;
  display: block;
  object-fit: cover;
  object-position: center center;
}

.btn.btn-primary {
  box-shadow: none !important;
}

.contentCards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.44rem;
  margin-top: 1rem;
  max-height: 240px;
  overflow-y: auto;
  border-radius: 10px;
}

.contentCards .cardIA {
  max-width: 65px;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}

.contentCards .cardIA .cardIcon {
  width: 100%;
  height: 65px;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contentCards .cardIA .cardIcon .overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: var(--slow);
}

.contentCards .cardIA .cardIcon .bx.bx-volume-full {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  color: var(--white);
  font-size: 28px;
  animation: fadeGrowingCenterFixed 0.4s linear;
}

.contentCards .cardIA .cardIcon.selected .overlay {
  opacity: 0.65;
}

.contentCards .cardIA .cardIcon img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  transition: var(--slow);
}

.contentCards .cardIA:hover .cardIcon img {
  transform: scale(1.3);
}

.contentCards .cardIA p {
  color: var(--black);
  text-align: center;
  font-size: 0.5rem;
  font-weight: 700;
  line-height: 1.25rem;
  margin: 0px;
}

.contentCards .cardIA:hover p {
  font-weight: 800;
}

.btn-primary:hover {
  opacity: 0.6;
}

small {
  font-size: 10px;
  text-align: center;
  display: block;
  max-width: 350px;
  margin: 15px auto 0px;
  text-shadow: 0px 0px 1.2px #fff;
}

small a {
  color: inherit;
  text-decoration: underline;
}

.isBackgroundImage small {
  text-shadow: 0px 0px 1.2px #000;
  color: #fff;
}

.content-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.content-body img {
  object-fit: contain;
  object-position: center center;
  width: 100px;
  height: 40px;
}

.btn-link {
  color: var(--purple-2);
  transition: var(--slow);
  cursor: pointer;
}

.btn-link:hover {
  text-decoration: underline;
}
</style>